var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Project"}},[_c('div',{staticClass:"projectsContainer"},_vm._l((_vm.projectLists),function(project,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(project.name)+" "),_c('el-divider')],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }